import React from 'react';
import { I18n } from 'react-redux-i18n-lite';
import laptopInfo from '../../styles/default/placeholders/laptop_info_icon.png';
import * as _ from 'lodash';

export default class UnitsErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { errorMessage: null };
  }

  componentDidCatch(error, info) {
    const { unitId, book } = this.props;
    if (unitId) {
      const unit = _.find(book.content, { activityId: unitId });
      if (!unit) {
        this.setState({ errorMessage: I18n.t('bookContainer.error') });
      } else {
        this.setState({ errorMessage: I18n.t('errorPage.title') });
      }
    } else {
      this.setState({ errorMessage: I18n.t('errorPage.title') });
    }
  }

  render() {
    if (this.state.errorMessage) {
      return (
        <div className="error-units">
          <img className="error-img" alt="error" src={laptopInfo} />
          <div className="error-message">{this.state.errorMessage}</div>
        </div>
      );
    } else if (this.props.children) {
      return this.props.children;
    }
    return null;
  }
}
